import DashboardIcon from '@mui/icons-material/SpaceDashboardOutlined'
import PeopleIcon from '@mui/icons-material/PeopleAltOutlined'
import StoreIcon from '@mui/icons-material/StorefrontOutlined'
import PhoneIcon from '@mui/icons-material/PhoneAndroidOutlined'
import EventIcon from '@mui/icons-material/EventAvailableOutlined'
import AssessmentIcon from '@mui/icons-material/AssessmentOutlined'
import HistoryIcon from '@mui/icons-material/HistoryOutlined'
import type { SvgIconComponent } from '@mui/icons-material'

export interface NavItem {
  label: string
  to: string
  icon: SvgIconComponent
}

export const navItems: NavItem[] = [
  { label: 'Panel', to: '/', icon: DashboardIcon },
  { label: 'Empleados', to: '/empleados', icon: PeopleIcon },
  { label: 'Sucursales', to: '/sucursales', icon: StoreIcon },
  { label: 'Dispositivos', to: '/dispositivos', icon: PhoneIcon },
  { label: 'Licencias', to: '/licencias', icon: EventIcon },
  { label: 'Reportes', to: '/reportes', icon: AssessmentIcon },
  { label: 'Auditoría', to: '/auditoria', icon: HistoryIcon },
]
